import React, { useState } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ContactActions from '../../../actions/contactActions';

import defaultClasses from '../../../components/BobTableContextMenu.module.css';

const SiteContactsContextMenu = ({
    handleAssignSite,
    handleUnassignSite,
    history,
    dataItem,
    setSelectedContact,
    view,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                {
                    view === 'assigned' ?
                        <MenuItem
                            onClick={() => handleUnassignSite(dataItem)}
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                        >
                            <span className="material-icons-outlined md-18">
                                close
                            </span>
                            Unassign
                        </MenuItem>
                        :
                        <MenuItem
                            onClick={() => handleAssignSite(dataItem)}
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                        >
                            <span className="material-icons-outlined md-18">
                                done
                            </span>
                            Assign
                        </MenuItem>
                }
            </Menu>
        </React.Fragment>
    );
};

const mapDispatchToProps = {
    ...ContactActions
};

export default withRouter(connect(null, mapDispatchToProps)(SiteContactsContextMenu));
